/**
 * Conteúdo dos slides padrão do totem.
 * Copiado do site (sitenetcomet/src/utils/residenciais.js e streamingCards.js).
 * Quando os planos mudarem no site, atualizar aqui também.
 */

export const MIDIA = '/totem/midia';

export type LogoId = 'watch' | 'deezer' | 'prime' | 'disney' | 'hbo' | 'telecine' | 'espn' | 'sportv' | 'premiere' | 'exitlag';

export const LOGOS: Record<LogoId, { nome: string; arquivo: string }> = {
	watch: {nome: 'Watch Brasil', arquivo: 'watch.png'},
	deezer: {nome: 'Deezer', arquivo: 'deezer.png'},
	prime: {nome: 'Sky+ com Amazon Prime', arquivo: 'prime.png'},
	disney: {nome: 'Disney+', arquivo: 'disney.png'},
	hbo: {nome: 'HBO Max', arquivo: 'hbo.png'},
	telecine: {nome: 'Telecine', arquivo: 'telecine.png'},
	espn: {nome: 'ESPN', arquivo: 'espn.png'},
	sportv: {nome: 'SporTV', arquivo: 'sportv.png'},
	premiere: {nome: 'Premiere', arquivo: 'premiere.png'},
	exitlag: {nome: 'ExitLag', arquivo: 'exitlag.png'},
};

export function logoUrl(id: LogoId) {
	return `${MIDIA}/logos/${LOGOS[id].arquivo}`;
}

/** Todas as imagens usadas pelos slides padrão, para pré-carregar no cache em memória do totem. */
export const MIDIAS_DOS_SLIDES: string[] = [
	`${MIDIA}/app_mockup.png`,
	`${MIDIA}/appstore.png`,
	`${MIDIA}/googleplay.webp`,
	...(Object.keys(LOGOS) as LogoId[]).map(logoUrl),
];

export type Plano = {
	nome: string;
	mega: string;
	preco: string; // reais
	centavos: string;
	itens: string[];
	logos: LogoId[];
	destaque?: boolean;
}

export const PLANOS_RESIDENCIAIS: Plano[] = [
	{
		nome: 'Basic',
		mega: '500',
		preco: '99',
		centavos: '90',
		itens: ['Netcomet TV', '20 canais by Watch'],
		logos: ['watch'],
	},
	{
		nome: 'Deezer + 800',
		mega: '800',
		preco: '119',
		centavos: '90',
		itens: ['Netcomet TV+', '20 canais + séries e filmes', 'Deezer incluso'],
		logos: ['watch', 'deezer'],
		destaque: true,
	},
	{
		nome: 'Disney+ 800',
		mega: '800',
		preco: '139',
		centavos: '90',
		itens: ['Netcomet TV+', '20 canais + séries e filmes', 'Disney+ incluso'],
		logos: ['watch', 'disney'],
	},
	{
		nome: 'ESPN + SporTV',
		mega: '800',
		preco: '139',
		centavos: '90',
		itens: ['Netcomet TV+', '63 canais + séries e filmes', 'ESPN e SporTV'],
		logos: ['watch', 'espn', 'sportv'],
	},
];

export const PLATAFORMAS_STREAMING: LogoId[] = ['watch', 'prime', 'disney', 'hbo', 'telecine', 'espn', 'sportv', 'premiere', 'deezer'];

export const APP_RECURSOS = [
	{icone: 'receipt_long', titulo: 'Faturas', texto: 'Segunda via, PIX e código do boleto na hora.'},
	{icone: 'description', titulo: 'Contrato', texto: 'Consulte seu plano e os dados do contrato.'},
	{icone: 'wifi', titulo: 'Conexão', texto: 'Veja como está sua conexão e peça desbloqueio.'},
];
